export default {"src":"/_next/static/media/archidekt.8905ab3f.svg","height":950,"width":950,"blurWidth":0,"blurHeight":0};